import { translator } from 'mage-i18n'
import * as PropTypes from 'prop-types'
import * as R from 'ramda'
import * as React from 'react'
import { connect } from 'react-redux'
import { FrameworkContext } from 'mage-deps/@klarna/mp-ui'

const StaticAppWrapper = ({ id, children, t, document }) => {
  const { setTopBarContext = () => {} } = React.useContext(FrameworkContext)
  document.title = t(`static-pages.${id}.pageTitle`)

  React.useEffect(() => {
    setTopBarContext({
      title: t(`static-pages.${id}.pageTitle`)
    })
    document.title = t(`static-pages.${id}.pageTitle`)
  }, [t])

  return (
    <div id={`static-pages_${id}`}>
      {children}
    </div>
  )
}

StaticAppWrapper.propTypes = {
  id: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
  children: PropTypes.node,
  document: PropTypes.shape({
    title: PropTypes.string
  })
}

StaticAppWrapper.defaultProps = {
  document: window.document
}

export default R.compose(
  connect(
    state => ({
      t: translator(state)
    })
  )
)(StaticAppWrapper)

export {
  StaticAppWrapper
}
